import EmailAddress from "_shared/email-addresses/email-address";
import Password from "users/auth/credentials/passwords/password";

export default class UserCredentials {
  public readonly email: EmailAddress;
  public readonly password: Password;

  public constructor(email: EmailAddress, password: Password) {
    this.email = email;
    this.password = password;
  }
}

export class InvalidCredentialsError extends Error {
  constructor() {
    super("Invalid credentials");
  }
}
